import type { SVGProps } from "react";
export interface BookOpenIconProps
  extends Omit<SVGProps<SVGSVGElement>, "width" | "height"> {
  className?: string;
  size?: number;
  color?: string;
}
export function BookOpenIcon({
  className = "",
  size = 24,
  color = "currentColor",
  ...props
}: BookOpenIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 24 24"
      className={className}
      {...props}
    >
      <path
        fill={color}
        d="M20.875 3.969c0-.498-.396-.86-.827-.845-1.337.043-2.858.17-4.211.505-1.198.296-2.126.722-2.711 1.274v11.275a17 17 0 0 1 2.2-.613c1.529-.328 3.193-.524 4.596-.623.558-.04.952-.486.953-.957V3.97ZM3.125 14c0 .47.395.915.95.954 1.404.097 3.068.29 4.597.615a17 17 0 0 1 2.204.61V4.92c-.586-.552-1.515-.979-2.713-1.275-1.354-.335-2.875-.462-4.212-.506-.43-.014-.826.347-.826.846zm20-.014c0 1.738-1.398 3.084-3.044 3.2-1.333.094-2.887.28-4.284.579-1.443.309-2.55.706-3.123 1.135-.4.3-.949.3-1.349 0-.57-.428-1.676-.823-3.12-1.13-1.397-.296-2.952-.478-4.285-.57C2.273 17.084.875 15.738.875 14V3.984C.875 2.282 2.256.833 4.025.89c1.4.045 3.101.178 4.678.568 1.15.284 2.337.73 3.287 1.46.954-.738 2.149-1.188 3.306-1.474 1.577-.39 3.28-.524 4.68-.569 1.768-.057 3.149 1.393 3.149 3.094z"
      />
      <path
        fill={color}
        d="M22 18.875a1.125 1.125 0 1 1 0 2.25c-1.193 0-3.134.12-5.009.423-.936.151-1.834.344-2.604.582-.787.243-1.364.51-1.713.77-.4.3-.949.3-1.349 0-.348-.26-.924-.527-1.71-.77-.771-.238-1.67-.43-2.607-.582-1.875-.302-3.815-.423-5.008-.423a1.125 1.125 0 0 1 0-2.25c1.307 0 3.368.129 5.367.451 1 .162 2.008.375 2.91.653a9.8 9.8 0 0 1 1.722.696 10 10 0 0 1 1.724-.696c.902-.278 1.91-.491 2.91-.653 2-.322 4.06-.451 5.367-.451"
      />
    </svg>
  );
}
